module.exports = "/_next/static/images/moneyalt-45565eb807bda26a4a79235ff88058c2.svg";